var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stream-editor"},[_c('components-panel',{staticClass:"stream-editor__side",attrs:{"initialized":_vm.initialized}}),_c('editor-panel',{staticClass:"stream-editor__main"}),_c('parameters-panel',{staticClass:"stream-editor__side"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }